import React from 'react';

export const EDIT_PROFILE_LABEL = 'Edit Profile';

interface ProfileEditButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> {
  iconClassName: string;
  iconStyle?: React.CSSProperties;
}

const ProfileEditButton: React.FC<ProfileEditButtonProps> = ({
  className,
  iconClassName,
  iconStyle,
  ...buttonProps
}) => (
  <button type="button" className={className} {...buttonProps}>
    <span className={iconClassName} style={iconStyle} aria-hidden="true" />
    {EDIT_PROFILE_LABEL}
  </button>
);

export default React.memo(ProfileEditButton);
